<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="allcont logsize m-top-i" *ngIf="this.totalAccountList > 0">
        <app-payment-component [dataPay]="this.paymentData" *ngIf="this.paymentscreen==1" (updatescreenview)="this.paymentscreen=$event"></app-payment-component>

        <div class="basicrow" *ngIf="this.paymentscreen!=1">
            <div class="container">
                <div class="basicr-line-i">
                    <div class="fulltitle  f-btitle autodef m-top-i">
                        <span class="icon-dash-21"></span> Regala 1 GB a un Pospago
                    </div>
                    <div class="pull-right pull-right-top">
                        <label class="label-r sidenmbr vcenter w-auto">
                                <span class="tabcell">
                                    N&uacute;mero de Cuenta
                                </span>
                            </label>
                        <div class="mob-wid pull-right">
                            <div>
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(../../assets/images/selectabarrw.png)">
                                        <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                            {{list.account}}</option>
                                    </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="basicrow m-top mbott-gift mbott-gift-a" *ngIf="this.paymentscreen!=1">
            <div class="container">
                <div class="autowcont allpads">
                    <div class="basicrow">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
                                <div class="basicrow hidden-xs">
                                    <img width="100%" class="webW" src="../../assets/images/regala1gbban.png">
                                </div>

                                <div class="regban-def visible-xs m-bott">
                                    <img width="100%" class="movilB" src="../../assets/images/regala1gbbanv2.png">
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                                <div class="basicrow">
                                    <div class="row">
                                        <div class="contenedor-numerotel">
                                            <label class="label-f">N&uacute;mero de mi Amigo/a</label>

                                            <div class="basicrow rel">

                                                <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="El número a ingresar debe ser un número de telefonía móvil de Claro Puerto Rico, Postpago." class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                                                <input [appOnlyNumber] class="inp-f qt" placeholder="Numero de teléfono" [(ngModel)]="this.subscriberReciever" maxlength="10" decimal-numbers>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="basicrow m-top">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <label class="label-f">Mensaje</label>

                                            <textarea placeholder="Mensaje de m&aacute;ximo 200 caracteres" [(ngModel)]="this.giftSendMessage" class="inp-f ta-reg" maxlength="200"></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="basicrow m-top">
                                    <input type="checkbox" (click)="this.activateTerms();"> Acepto los <span (click)="this.showterms();" class="linkdefsnet">T&eacute;rminos y
                                        Condiciones&nbsp;&nbsp;<i class="fa fa-angle-right"
                                            aria-hidden="true"></i></span>
                                </div>

                                <div class="basicrow m-top">
                                    <div class="row">
                                        <div class="contenedor-unagiga">
                                            <div class="basicrow rel">
                                                <div class="reg-txt">
                                                    1GB
                                                </div>

                                                <input value="&#36;{{this.amount}}" class="inp-f payup-i">

                                                <a class="btns red payup-i vcenter" (click)="this.addGift();">
                                                    <span class="tabcell">
                                                        Regalar&nbsp;&nbsp;<i class="fa fa-angle-right"
                                                            aria-hidden="true"></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>